export default __webpack_public_path__ + "static/media/testimonial-img-10.bb3e743c.jpg";